import { Flex } from "@chakra-ui/react";
import * as React from "react";
import "./index.css";

export class ComponentToPrint extends React.PureComponent {
  render() {
    const { mainorder } = this.props;
    const CustomerShirtSize = mainorder?.customer?.shirt;
    const CustomerPantSize = mainorder?.customer?.pant;
    const orderDetails = mainorder;

    let total = parseInt(orderDetails.price);
    let advance = parseInt(orderDetails.advance);
    let balance = parseInt(orderDetails.balance);
    let starchprice = parseInt(orderDetails.starchprice) || 0;

    return (
      <Flex direction="column">
        <div className="invoice-box">
          <table cellPadding="0" cellSpacing="0">
            <tbody>
              <tr className="top">
                <td colSpan="3">
                  <table>
                    <tbody>
                      <tr>
                        <td
                          className="title"
                          style={{ width: "300px", height: "200px" }}
                        >
                          <img src="/logo.jpg" alt="Anand Tailors"></img>
                        </td>
                        <td></td>
                        <td style={{ textAlign: "end" }}>
                          पावती क्रमांक # {mainorder?.id}
                          <br />
                          ऑर्डर दिलेली तारीख:{" "}
                          {mainorder?.orderDate?.slice(0, 10)}
                          <br />
                          डिलिव्हरी तारीख:{" "}
                          {mainorder?.deliveryDate?.slice(0, 10)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
            <tbody>
              <tr className="information">
                <td colSpan="3">
                  <table>
                    <tbody>
                      <tr>
                        <td>
                          {mainorder?.customer?.name},
                          <br />
                          {mainorder?.customer?.address}
                          <br />
                          {mainorder?.customer?.phonenumber}
                          <br />
                        </td>
                        <td>
                          आनंद टेलर्स,
                          <br />
                          सरकारी दवाखान्याजवळ,
                          <br />
                          अकलूज,जिल्हा-सोलापूर
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
            <tbody>
              <tr className="heading">
                <td>तपशील </td>
                <td></td>
                <td className="price-section"> नग</td>
              </tr>
            </tbody>

            <tbody>
              <tr className="item">
                <td>पँट</td>
                <td></td>
                <td className="price-section">
                  {mainorder?.pantorders?.length}
                </td>
              </tr>
            </tbody>
            <tbody>
              <tr className="item">
                <td>शर्ट </td>
                <td></td>
                <td className="price-section">
                  {mainorder?.shirtorders?.length}
                </td>
              </tr>
            </tbody>
            <tbody style={{ borderTop: "2px solid black" }}>
              <tr className="total">
                <td></td>
                <td></td>
                <td className="price-section">एकूण: {total}</td>
              </tr>
            </tbody>
            <tbody>
              <tr>
                <td></td>
                <td></td>
                <td className="price-section">आगाऊ: {advance}</td>
              </tr>
            </tbody>
            <tbody>
              <tr>
                <td></td>
                <td></td>
                <td className="price-section">शिल्लक: {balance}</td>
              </tr>
            </tbody>
            <tbody>
              <tr>
                <td></td>
                <td></td>
                <td className="price-section">स्टार्च किंमत: {starchprice}</td>
              </tr>
            </tbody>
          </table>
          <ul title="टीप:" style={{ borderTop: "2px solid black" }}>
            <li style={{ marginTop: "10px" }}>
              <p> तीन महिन्याचा आत कपडे न नेल्यास आम्ही जबाबदार नाही.</p>
            </li>
            <li>
              <p> पावती शिवाय कपडे मिळणार नाहीत.</p>
            </li>
            <li>
              <p>
                फिटिंग बाबत तक्रार असल्यास कपडे धुतल्यानंतर अथवा लौंड्रीत
                टाकल्यास.
              </p>
            </li>
            <li>
              <p>कपडे आकसल्यास आम्ही जबाबदार नाही.</p>
            </li>
          </ul>
          <Flex>
            <div style={{ display: "contents", flexWrap: "wrap" }}>
              {mainorder.pantorders
                ? mainorder?.pantorders?.map((data, index) => {
                    return (
                      <div key={index} className="pantOrderClass">
                        <h1>
                          <u>पँटचे प्रकार: {data.pantcategory.category}</u>
                        </h1>
                        <h1 style={{ display: "flex" }}>
                          <u>
                            पँटचे ऑपशन:
                            {data.pantoptions.map((option, index) => (
                              <span
                                key={index}
                                style={{ margin: "10px 10px 5px 10px" }}
                              >
                                {option.option}
                              </span>
                            ))}
                          </u>
                        </h1>
                        <p>
                          <u>बॉटम: {CustomerPantSize.bottom}</u>
                        </p>
                        <p>
                          <u>गुडगा: {CustomerPantSize.gudga}</u>
                        </p>
                        <p>
                          <u>उंची: {CustomerPantSize.height}</u>
                        </p>
                        <p>
                          <u>कंबर: {CustomerPantSize.kambar}</u>
                        </p>
                        <p>
                          <u>मांडी: {CustomerPantSize.mandi}</u>
                        </p>
                        <p>
                          <u>सीट: {CustomerPantSize.seat}</u>
                        </p>
                      </div>
                    );
                  })
                : null}
            </div>

            <div style={{ display: "flex", flexWrap: "wrap" }}>
              {mainorder.shirtorders
                ? mainorder?.shirtorders?.map((data, index) => {
                    return (
                      <div className="shirtOrderClass" key={index}>
                        <h1>
                          <u>शर्टचा प्रकार: {data.shirtcategory.category}</u>
                        </h1>
                        <h1 style={{ display: "flex" }}>
                          <u>
                            शर्टचे ऑपशन:
                            {data.shirtoptions.map((option, index) => (
                              <span
                                key={index}
                                style={{ margin: "10px 10px 5px 10px" }}
                              >
                                {option.option}
                              </span>
                            ))}
                          </u>{" "}
                        </h1>
                        <p>
                          <u>उंची: {CustomerShirtSize.height}</u>
                        </p>
                        <p>
                          <u>छाती: {CustomerShirtSize.chest}</u>
                        </p>
                        <p>
                          <u>पोट: {CustomerShirtSize.pot}</u>
                        </p>
                        <p>
                          <u>सीट: {CustomerShirtSize.seat}</u>
                        </p>
                        <p>
                          <u>फ्रंट: {CustomerShirtSize.front}</u>
                        </p>
                        <p>
                          <u>पोट: {CustomerShirtSize.stomach}</u>
                        </p>
                        <p>
                          <u>शोल्डर: {CustomerShirtSize.shoulder}</u>
                        </p>
                        <p>
                          <u>भाई: {CustomerShirtSize.bhai}</u>
                        </p>
                        <p>
                          <u>गळा: {CustomerShirtSize.throat}</u>
                        </p>
                        <p>
                          <u>कप: {CustomerShirtSize.cup}</u>
                        </p>
                        <p>
                          <u>बॅग: {CustomerShirtSize.bag}</u>
                        </p>
                        <p>
                          <u>भाई लूझिंग: {CustomerShirtSize.bhailoosing}</u>
                        </p>
                      </div>
                    );
                  })
                : null}
            </div>
          </Flex>
        </div>
      </Flex>
    );
  }
}
